import React from "react";
import TravelTourismManagementHeader from "../components/Courses/TravelTourismManagement/TravelTourismManagementHeader";
import TravelTourismManagementCareerSkills from "../components/Courses/TravelTourismManagement/TravelTourismManagementCareerSkills";
import TravelTourismManagementProgramsCard from "../components/Courses/TravelTourismManagement/ExploreProgramsTravelTourismManagement";
import TravelTourismManagementAdmissionRequirements from "../components/Courses/TravelTourismManagement/TravelTourismManagementAdmissionRequirements";
import FullScreenImage from "../components/Home/ShowcaseSection";
import Footer from "../components/sub-comp/MainFooter";
import Navbar from "../components/sub-comp/Navbar";

const TravelTourismManagement = () => {
  return (
    <div>
      <Navbar />
      <TravelTourismManagementHeader />
      <TravelTourismManagementCareerSkills />
      <TravelTourismManagementProgramsCard />
      <TravelTourismManagementAdmissionRequirements />
      <FullScreenImage />
      <Footer />
    </div>
  );
};

export default TravelTourismManagement;
